import { render, staticRenderFns } from "./ChildLevelRelevancy.vue?vue&type=template&id=0002aa32&scoped=true&"
import script from "./ChildLevelRelevancy.vue?vue&type=script&lang=js&"
export * from "./ChildLevelRelevancy.vue?vue&type=script&lang=js&"
import style0 from "./ChildLevelRelevancy.vue?vue&type=style&index=0&id=0002aa32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002aa32",
  null
  
)

export default component.exports